/**
 * KeyIcon/index.js
 * desc: key icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const KeyIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="key icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.key.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 758 1600" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M437.262 1582.76L567.216 1453.98L567.216 699.631C680.852 635.136 757.549 514.098 757.242 375.138C757.675 168.111 588.296 0.470939 379.656 0.00427246C170.522 0.467819 1.16216 168.124 0.842163 375.138C1.06612 513.711 77.5302 634.484 190.856 699.084V850.818L311.017 971.011L219.033 1062.96L307.32 1151.24L216.648 1241.94L308.554 1333.89L216.648 1425.84L373.528 1582.79C397.158 1605.46 413.736 1606.04 437.252 1582.77L437.262 1582.76ZM280.316 210.898C280.826 155.57 325.852 111.075 380.894 111.586C436.686 111.075 481.681 155.57 481.421 210.898C481.707 265.314 436.686 309.81 380.894 310.226C325.853 309.825 280.848 265.33 280.316 210.898Z"/>
        </svg>
    </IconButton>
);


export default KeyIcon;
